import { render } from "./modalUser.vue?vue&type=template&id=293afd88"
import script from "./modalUser.vue?vue&type=script&lang=js"
export * from "./modalUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__